import React from 'react';

interface EvaluatorHeaderProps {
  onBackToOverview: () => void;
  isRevision: boolean;
  isDraft: boolean;
}

const EvaluatorHeader: React.FC<EvaluatorHeaderProps> = ({
  onBackToOverview,
  isRevision,
  isDraft,
}) => {
  return (
    <div className="flex items-center justify-between">
      {/* Back to Overview Button */}
      <button
        onClick={onBackToOverview}
        className="flex items-center gap-2 px-4 py-2 text-sm font-semibold text-white bg-black hover:bg-gray-800 rounded-lg transition-colors font-baijamjuree"
      >
        <svg
          className="w-4 h-4"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M15 19l-7-7 7-7"
          />
        </svg>
        Back to Overview
      </button>

      {/* Evaluation Status Indicator */}
      <div className="flex items-center gap-2">
        {isRevision && (
          <span
            className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium font-baijamjuree ${
              isDraft
                ? 'bg-yellow-100 text-yellow-800'
                : 'bg-green-100 text-green-800'
            }`}
          >
            {isDraft ? '📝 Draft - Can be revised' : '✅ Completed'}
          </span>
        )}
      </div>
    </div>
  );
};

export default EvaluatorHeader;
